const state = {
  isLoading: false,
  list: [],
  invoiceFilter: {},
  isInvoiceLoading: false,
  invoicelist: [],
  comments: [],
  commentLoading: false,
  isUploading: false,
  invoiceType: { id: 0, name: 'All Invoices' },
  indentType: { id: 0, name: 'All Indents' },
  vehicleType: { id: 0, name: 'All' },
  isEmptyPaginate: false,
};

export default state;
